const Api =
  'https://us-central1-floristeria-honduras-dev.cloudfunctions.net/sendHint';

function sendHint(data) {
  const {email, name, recipient_name, imagen, message, url} = data;

  return fetch(Api, {
    method: 'POST',
    headers: {'content-type': 'application/json'},
    body: JSON.stringify({
      email,
      name,
      recipient_name,
      imagen,
      message,
      url,
    }),
  })
    .then(response => {
      if (response.ok) {
        console.log('exito');
      } else {
        console.log('error, no se pudo obtener la data');
      }
    })
    .catch(function(error) {
      console.log(error, 'error encontrado');
    });
}

export {sendHint};
